import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  className?: string; 
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, className, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={className}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const TabsComponent = () => {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className="stepper py-12 sm:py-20">
      <div className="container">
        <h2 className="text-center text-4xl sm:text-6xl font-bold mb-4 uppercase">{t('prices.title')}</h2>
        <p className="text-center mb-12">{t('prices.description')}</p>
        <Box className="single-tab-container" sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs  value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab className="single-tab" label={t('prices.section1.title')} {...a11yProps(0)} />
                  <Tab className="single-tab" label={t('prices.section2.title')} {...a11yProps(1)} />
                </Tabs>
              </Box>
              <CustomTabPanel className="single-content" value={value} index={0}>
                <h5 className="text-4xl font-bold mb-4">{t('prices.section1.price')}</h5>
                <p className="mb-4 font-bold">{t('prices.section1.description')}</p>
                <ul className="list-disc list-inside">
                  <li>{t('prices.section1.item1')}</li>
                  <li>{t('prices.section1.item2')}</li>
                  <li>{t('prices.section1.item3')}</li>
                </ul>
              </CustomTabPanel>
              <CustomTabPanel className="single-content" value={value} index={1}>
                <h5 className="text-4xl font-bold mb-4">{t('prices.section2.price')}</h5>
                <p className="mb-4 font-bold">{t('prices.section2.description')}</p>
                <ul className="list-disc list-inside">
                  <li>{t('prices.section2.item1')}</li>
                  <li>{t('prices.section2.item2')}</li>
                  <li>{t('prices.section2.item3')}</li>
                </ul>
              </CustomTabPanel>

            </Box>
        </div>
    </div>
  );
};